import { Container, Typography } from "@mui/material";

export default function NotFound() {
    return <Container>
        <Typography>Not found</Typography>
    </Container>
}